import Collapse from 'bootstrap/js/dist/collapse';

(function loginDesktop() {
  // Get a reference to the login desktop component
  const loginElement: HTMLElement | null = document.querySelector('[data-component="login-desktop-component"]');
  if (!loginElement) return;

  // Get a reference to the arrow icon element shown search menu item when the search is open
  const menuArrowIconElement: HTMLElement | null = document.querySelector('[data-component="secondary-menu-desktop-login-menu-arrow"]');

  // Get a reference to the search desktop component
  const searchElement: HTMLElement | null = document.querySelector('[data-component="site-search-desktop-component"]');

  // Hide the login component when the search component is shown
  if (searchElement) {
    searchElement.addEventListener('show.bs.collapse', () => {
      Collapse.getInstance(loginElement)?.hide();
    });
  }

  // Show the arrow icon when the search component is shown
  loginElement.addEventListener('show.bs.collapse', () => {
    menuArrowIconElement?.classList.remove('d-none');
  });
  loginElement.addEventListener('hide.bs.collapse', () => {
    menuArrowIconElement?.classList.add('d-none');
  });
})();
